import { ArticleCard } from "@/ui/article-card"
import { SanityImageAsset, SanityReference } from "sanity-codegen"

interface ArticlesGridProps {
  content: {
    highlighted: {
      previewCover: {
        asset: SanityReference<SanityImageAsset>
      }
      previewDescription: string
      previewTitle: string
      slug: string
      tag: string
    }[]
  }
}

export function ArticlesGrid({ content }: ArticlesGridProps) {
  return (
    <div className="mx-auto max-w-[137rem] gap-6 px-6 py-12">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {content.highlighted.map((article, i) => (
          <ArticleCard
            key={i}
            title={article.previewTitle}
            description={article.previewDescription}
            image={article.previewCover}
            label={article.tag}
            size="lg"
          />
        ))}
      </div>
      <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
        {content.highlighted.map((article, i) => (
          <ArticleCard
            key={i}
            title={article.previewTitle}
            description={article.previewDescription}
            image={article.previewCover}
            label={article.tag}
            size="md"
          />
        ))}
      </div>
    </div>
  )
}
